import React from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaWhatsapp, FaLinkedin } from 'react-icons/fa';
import logo from '../assets/logo.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section" data-aos="fade-up">
            <div className="footer-logo-container">
              <img src={logo} alt="Shawave Technologies" className="footer-logo-image" />
            </div>
            <p className="footer-description">
              Transforming digital visions into reality with cutting-edge web and mobile solutions.
            </p>
            <div className="social-links">
              <a href="https://wa.me/919959019781" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
              <a href="https://www.linkedin.com/in/sunanth-samala-818b2b169?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
              <a href="mailto:sunanth.samala7@gmail.com" aria-label="Email"><FaEnvelope /></a>
            </div>
          </div>
          <div className="footer-section" data-aos="fade-up" data-aos-delay="100">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Web Development</a></li>
              <li><a href="#services">Mobile App Development</a></li>
              <li><a href="#services">E-Commerce Solutions</a></li>
              <li><a href="#services">Full Stack Development</a></li>
            </ul>
          </div>
          <div className="footer-section" data-aos="fade-up" data-aos-delay="200">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-links">
              <li><a href="#hero">About Us</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#">Privacy Policy</a></li>
            </ul>
          </div>
          <div className="footer-section" data-aos="fade-up" data-aos-delay="300">
            <h4 className="footer-title">Contact Us</h4>
            <ul className="footer-contact">
                  <li>
                    <FaEnvelope />
                    <span>sunanth.samala7@gmail.com</span>
                  </li>
                  <li>
                    <FaPhone />
                    <span>+91 9959019781</span>
                  </li>
              <li>
                <FaMapMarkerAlt />
                <span>India</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Shawave Technologies — Building the future, one product at a time.</p>
          <div className="footer-nav">
            <a href="#hero">Home</a>
            <span>•</span>
            <a href="#services">Services</a>
            <span>•</span>
            <a href="#about">About</a>
            <span>•</span>
            <a href="#pricing">Pricing</a>
            <span>•</span>
            <a href="#contact">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

